import React, { useEffect, useState } from "react";
import Product from "../components/Product";
import ProductSkeleton from "../components/ProductSkeleton";
import ProfileUnavailable from "./profile-unavailable";
import { TopicIcon } from "../assets/imageAssets";
import { useNavigate, useParams } from "react-router-dom";
import { profilesIdTopics_req, userActivity_req } from "../api/profiles.api";
import { useDispatch, useSelector } from "react-redux";
import { setTopicsTree } from "../redux/topics.slice";

const WorkPayExplorer = ({ seconds }) => {
  const { profileId } = useParams();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const sessionId = useSelector((state) => state.me.sessionData);

  const [data, setData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [profileMissing, setProfileMissing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getProfileTopics = async () => {
    try {
      const response = await profilesIdTopics_req(profileId);
      const profile = response?.result?.profile;
      const topics = response?.result?.topics || [];
      setProfileData(profile);
      setData(topics);
      dispatch(setTopicsTree({
        profileId: Number(profileId),
        profileName: profile?.name,
        topicsTree: topics,
      }));
    } catch (error) {
      if (error?.response?.status === 404) {
        setProfileMissing(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setProfileMissing(false);
    setIsLoading(true);
    getProfileTopics();
  }, [profileId]);

  if (isLoading) {
    return <ProductSkeleton levelIcon={TopicIcon} />;
  }

  if (profileMissing) {
    return <ProfileUnavailable />;
  }

  const handleTopicClick = async (topicId, item) => {
    await userActivity_req(sessionId, seconds, "work_pay_explorer");
    if (item?.is_question) {
      navigation(`/profiles/${profileId}/topics/${topicId}/questions`);
    } else {
      navigation(`/profiles/${profileId}/topics/${topicId}`);
    }
  };

  return (
    <Product
      title={profileData?.name}
      description={profileData?.description}
      levelIcon={TopicIcon}
      pageColor={"purple"}
      topicsList={data}
      onTopicClick={handleTopicClick}
    />
  );
};

export default WorkPayExplorer;
